/** Tọa độ mặc định (TP.HCM) khi không có GPS hợp lệ. */
export const DEFAULT_MAP_CENTER = [10.7769, 106.7009];

export function normalizeLocationString(loc) {
  if (loc == null || loc === "") return "";
  if (typeof loc === "object" && !Array.isArray(loc)) {
    const lat = loc.lat ?? loc.latitude;
    const lon = loc.lon ?? loc.lng ?? loc.longitude;
    if (lat != null && lon != null) return `${String(lat).trim()}, ${String(lon).trim()}`;
  }
  return String(loc).trim();
}

function isValidCoordPair(lat, lng) {
  return (
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180
  );
}

/** Trả về [lat, lng] hoặc null nếu không parse được. */
export function parseLatLng(loc) {
  if (loc == null || loc === "") return null;

  if (typeof loc === "object" && !Array.isArray(loc)) {
    const lat = Number(loc.lat ?? loc.latitude);
    const lng = Number(loc.lon ?? loc.lng ?? loc.longitude);
    return isValidCoordPair(lat, lng) ? [lat, lng] : null;
  }

  const raw = normalizeLocationString(loc);
  if (!raw || raw === "Không xác định" || !raw.includes(",")) return null;

  const parts = raw.split(",").map((s) => Number(String(s).trim()));
  if (parts.length < 2) return null;

  const [lat, lng] = parts;
  return isValidCoordPair(lat, lng) ? [lat, lng] : null;
}

export function hasValidGps(loc) {
  return parseLatLng(loc) !== null;
}
